import axios from 'axios'
axios.defaults.baseURL = process.env.REACT_APP_URL
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers.post['Content-Type'] = 'application/json'
  config.headers.common.Accept = 'application/json'
  // config.headers.post['Access-Control-Allow-Origin'] = '*'

  const userObject = localStorage.getItem('__session_polac_physical')
  if (userObject !== null) { config.headers.common.Authorization = +JSON.parse(userObject)?.token }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
axios.interceptors.response.use(function (config) {
  config.headers['cache-control'] = 'no-cache, no-store, must-revalidate'
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
const authService = {

  createUserAccountApi: (data) => {
    return axios.post('cpanel/user-account/save', data)
  },
  getRoles: async () => {
    return await axios.get('cpanel/user-account/list-role')
  },

  getRank: async () => {
    return await axios.get('cpanel/user-account/list-rank')
  },
  getZone: async () => {
    return await axios.get('cpanel/user-account/list-zone')
  },
  getDepartment: async () => {
    return await axios.get('cpanel/user-account/list-department')
  },

  profileUpdate: async (data) => {
    return await axios.post('cpanel/user-account/save-status', data)
  },
  deleteAdmin: async (data) => {
    return await axios.post('/cpanel/user-account/delete', data)
  },
  lockAdmin: async (data) => {
    console.log('data payload', data)
    return await axios.post('/cpanel/user-account/save-status', data)
  },
  changeRole: async (data) => {
    return await axios.post('cpanel/user-account/save-status', data)
  },

  passwordReset: async (data) => {
    return await axios.post('/cpanel/user-account/save-status', data)
  },

  allUserApi: async () => {
    return await axios.get('/cpanel/user-account/fetch-list')
  }

}

export default authService
